import React from "react";
import { connect } from "react-redux";
import {
  callAuthSaveInternalInfo,
  callAuthSubmitInternalPayment,
  callAuthCheckPayoff,
} from "../../../actions/authPayment.actions";
import { AuthPaymentInternalTransfer } from "../payment-forms/auth-payment-internal-transfer-form.component";
import { AuthInternalTransferReview } from "../review/auth-internal-transfer-review-fields.component";
import { AuthPaymentInternalTransferSummary } from "../summary/auth-payment-internal-transfer-summary.component";
import { usd } from "../../../utils/utils";
import moment from "moment";

const StandardInternalTransferFlowComponent = (props) => {
  const currentForm = props.form["AuthPaymentInternalTransfer"];
  const paymentResponse = props.authPayment.paymentResponse;
  const internalResponse = props.authPayment.internalResponse;
  const payoffCheckResponse = props.authPayment.payoffCheck;
  const amountPastDueBetweenPayoffAndBalance = props.amountPastDueBetweenPayoffAndBalance;

  const isPrincipalOnly = props.paymentInfo.isPrincipalOnly;
  const hasSelectedPayoff = props.paymentInfo.hasSelectedPayoff;

  const { setProcessStep, processStep, selectedLoan, backToLoans } = props;

  const paymentAccount = () => {
    if (currentForm.values) {
      return props.authPayment.internalAccounts.filter(
        (account) => account.AccountHash === currentForm.values.AccountHash
      )[0];
    }

    return null;
  };

  switch (processStep) {
    case 1:
      return (
        <AuthPaymentInternalTransfer
          {...props.authPayment.selectedLoanAdditionalDetails}
          authPayment={props.authPayment}
          setProcessStep={setProcessStep}
          selectedLoan={selectedLoan}
          internalAccounts={props.authPayment.internalAccounts}
          thisForm={currentForm}
          callAuthCheckPayoff={props.callAuthCheckPayoff}
          callAuthSaveInternalInfo={props.callAuthSaveInternalInfo}
          internalResponse={internalResponse}
          isPrincipalOnly={isPrincipalOnly}
          hasSelectedPayoff={hasSelectedPayoff}
          backToLoans={backToLoans}
          amountPastDueBetweenPayoffAndBalance={amountPastDueBetweenPayoffAndBalance}
        />
      );
    case 2:
      return (
        <AuthInternalTransferReview
          paymentAppliedDate={moment(internalResponse.PostDate).format("MM/DD/YYYY")}
          paymentAccount={paymentAccount()}
          paymentAmount={usd.format(internalResponse.PaymentAmount)}
          internalTransferFormValues={currentForm.values}
          selectedLoan={selectedLoan}
          setProcessStep={setProcessStep}
          paymentResponse={paymentResponse}
          isPayoff={payoffCheckResponse.PaymentTypeChangedToPayoff}
          callAuthSubmitInternalPayment={props.callAuthSubmitInternalPayment}
          backToLoans={backToLoans}
        />
      );
    case 3:
      return (
        <AuthPaymentInternalTransferSummary
          paymentAppliedDate={moment(paymentResponse.PostDate).format("MM/DD/YYYY")}
          paymentAccount={paymentAccount()}
          paymentAmount={usd.format(paymentResponse.PaymentAmount)}
          isPayoff={payoffCheckResponse.PaymentTypeChangedToPayoff}
          confirmationEmail={paymentResponse.EmailAddress}
          selectedLoan={selectedLoan}
          isPrincipalOnly={isPrincipalOnly}
          backToLoans={backToLoans}
        />
      );
    case 4:
      return <div>Step 4</div>;
    default:
      return <div>Something has gone wrong.</div>;
  }
};

const mapDispatchToProps = {
  callAuthSaveInternalInfo,
  callAuthSubmitInternalPayment,
  callAuthCheckPayoff,
};

const StandardInternalTransferFlow = connect(
  null,
  mapDispatchToProps
)(StandardInternalTransferFlowComponent);

export default StandardInternalTransferFlow;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/flow-components/standard-internal-transfer-flow.component.js